import React, { createContext, useState } from 'react'

export const ContextReports = createContext()

const Provider = ({ children }) => {
  const [urlReport, setUrlReport] = useState('')
  const [prevfile, setPrevFile] = useState('')

  const value = {
    urlReport,
    prevfile,
    setUrlReport: item => {
      setUrlReport(item)
    },
    setPrevFile: item => {
      setPrevFile(item)
    },
  }

  return <ContextReports.Provider value={value}>{children}</ContextReports.Provider>
}
export default {
  Provider,
  Consumer: ContextReports.Consumer,
}
